import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import requiredSetupMappings from '../../../../components/required-setup-mappings';
import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';
import RequestFeedbackManager from '../../../../components/request-feedback-manager';

import CurrentForecastPage from '../CurrentForecastPage';
import HistoryForecastPage from '../HistoryForecastPage/HistoryForecastPage';

function ForecastPage(props) {
  const { location: { pathname } } = props;
  return (
    <div>
      <Helmet title="Forecast" />
      <RequestFeedbackManager />
      <div className="container">
        <div className="clearfix">
          <h1 className="page-header">
            Forecast
          </h1>
        </div>
      </div>
      <Switch>
        <Route path="/forecast/current" component={CurrentForecastPage} />
        <Route path="/forecast/history" component={HistoryForecastPage} />
        {(pathname === '/forecast' && <Redirect to="/forecast/current" />)}
      </Switch>
    </div>
  );
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}

ForecastPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

ForecastPage.contextTypes = {
  router: PropTypes.object,
};
export default connect(mapStateToProps)(orgAwearness(requiredSync(requiredSetupMappings(withRouter(ForecastPage), ['stage', 'dealType']))));
